import React from "react";
import PropertyCard from "./PropertyCard";
import "./FeaturedProperties.css";
import resaleproperties1 from "../img/resaleproperties/resaleproperties1.png";
import resaleproperties2 from "../img/resaleproperties/resaleproperties2.png";
import resaleproperties3 from "../img/resaleproperties/resaleproperties3.png";
import resaleproperties4 from "../img/resaleproperties/resaleproperties4.png";

function FeaturedProperties() {
  return (
    <div className="FeaturedProperties">
      <div className="FeaturedProperties__title">
        <h1>Distinctive Resale Residence</h1>
      </div>
      <div className="FeaturedProperties__subtitle">
        <p>
      
        </p>
      </div>
      <div className="FeaturedProperties__cards">
        <PropertyCard
         img="https://i.postimg.cc/nV3g2HjW/Frame-63-7.png"
         name="Luxury Mansion With Large Land"
         location="Pego - SPAIN"
         price="2,495,000€"
         bedrooms="9"
         bathrooms="8"
         housesize="2 014 m²"
     status=""
         badgecolor=""
         slug="LUXURY_MANSION_WITH_LARGE_LAND_CFP-RE4002"
        />
        <PropertyCard
         img="https://i.postimg.cc/MZYgLDpf/Frame-63-5.png"
         name="Rustic Villa"
         location="Benissa - SPAIN"
         price="2,200,000€"
         bedrooms="5"
         bathrooms="3"
         housesize="296 m²"
  status=""
         badgecolor=""
         slug="RUSTIC_VILLA_PANORAMIC_VIEWS_CFP-RU3001"
        />
        <PropertyCard
        img="https://i.postimg.cc/brcPt14g/thumnail.png"
        name="Luxury Villa"
        location="Costa Blanca - SPAIN"
        price="5,900,000€"
        bedrooms="7"
        bathrooms="7"
        housesize="611 m²"
       status=""
         badgecolor=""
        slug="LUXURY_VILLA_PANORAMIC_VIEW_RU3002"
        />
        <PropertyCard
         img="https://i.postimg.cc/HsN4bRPD/Frame-63-5.png"
         name="Modern Villa"
         location="Benitachell - SPAIN"
         price="1,150,000€"
         bedrooms="4"
         bathrooms="4"
         housesize="417 m²"
    status=""
         badgecolor=""
         slug="MODERN_VILLA_CUMBRE_DEL_SOL_COSTA_BLANCA_SPAIN_CFP-M2027"
        />
      </div>
      <div className="FeaturedProperties__viewmore">
        <a href="/ResaleProperties">
          <p>View more</p>
        </a>
      </div>
    </div>
  );
}

export default FeaturedProperties;
